<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'
import { graphic } from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
   if(obj.dataZoom && obj.dataZoom.show) {
    obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
    } else {
    obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
   }
    processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
      newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
      jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
      processData(cptDataForm,newData,jsFunFlag)
      loadChart(props.option.attribute);
    })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                        res.forEach(item => {
                          let name = item[dataKey[0].value];
                          let value = item[dataKey[1].value];

                          // 创建新的对象并添加到 aa 数组中
                          newarr.push({ name, value });
                        });
                        console.log(newarr,'新数组')
                        cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
    }
function loadChart(attribute) {
  let attr = JSON.parse(JSON.stringify(attribute))//watch循环修复，xAxis指向的对象被更改影响

  let xAxisType = 'category';
  let yAxisType= 'value';
  let x2 = 1;
  let y2 = 0;
  let barX = 0;
  let barY2 = 1;
  let endSymbolOffset = ["0%", "-50%"];
  let startSymbolOffset = ["0%", "50%"];
  let symbolSize = [attr.series.barWidth, 10];
  if(attr.direction === 'y'){
    xAxisType = 'value';
    yAxisType ='category';
    x2 = 0;
    y2 = 1;
    barX = 1;
    barY2 = 0;
    endSymbolOffset = ["50%", "0%"];
    startSymbolOffset = ["-50%", "0%"];
    symbolSize = [10, attr.series.barWidth];
  }
  const bottomColor = {
    type: "linear", x: 0, x2: x2, y: 0, y2: y2,
    colorStops: [
      {offset: 0, color: attr.color[0]},
      {offset: 0.3, color: attr.color[0]},
      {offset: 0.3, color: attr.color[2]},
      {offset: 1, color: attr.color[2]},
    ],
  };

  let barColor = [
    new graphic.LinearGradient(
        barX, 0, 0, barY2,
        [
          {offset: 0, color: attr.color[1]},
          {offset: 1, color: attr.color[0]}
        ]),
    new graphic.LinearGradient(
        barX, 0, 0, barY2,
        [
          {offset: 0, color: attr.color[3]},
          {offset: 1, color: attr.color[2]}
        ])
  ];

  const data = []
  let axisData  = []
  cptData.forEach(item => {
    data.push(item.value)
    axisData.push(item.name)
  })
  chartOption = {
    color: barColor,
    title: attr.title,
    grid: attr.grid,
    xAxis: attr.xAxis,
    yAxis: attr.yAxis,
    legend: attr.legend,
    dataZoom:attr.dataZoom,
    tooltip: {
      trigger: 'axis',
      ...attr.tooltip,
    },
    series: [
      {
        type: 'bar',
        barWidth: attr.series.barWidth * 0.3,
        data: data,
        barGap: 0,
        tooltip: { show: false }
      }, {
        type: 'bar',
        barWidth: attr.series.barWidth * 0.7,
        barGap: 0,
        data: data,
        label: attr.series.label
      }, {
        type: 'pictorialBar',
        itemStyle: {
          color: attr.color[3]
        },
        symbol: 'diamond',
        symbolSize: symbolSize,
        symbolOffset: endSymbolOffset,
        symbolPosition: 'end',
        data: data,
        z: 3,
        tooltip: { show: false }
      }, {
        type: 'pictorialBar',
        itemStyle: {
          color: bottomColor
        },
        symbol: 'diamond',
        symbolSize: symbolSize,
        symbolOffset: startSymbolOffset,
        data: data,
        z: 3,
        tooltip: { show: false }
      }
    ]
  }
  chartOption.xAxis.type = xAxisType
  chartOption.yAxis.type = yAxisType
  chartOption.xAxis.data = axisData
  chartOption.yAxis.data = axisData

  chart.setOption(chartOption,true);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}
defineExpose({refreshCptData})
</script>

<style scoped>

</style>
